import { useTranslation } from 'react-i18next'
import { Input } from '@/components/shadcn/input'
import { HelpLabel } from '@/components/common/help/HelpLabel'
import { helpKey } from '@/lib/action-modules/help'
import { isScoreMultiplyRewardCalculationTypeModel, type RewardCalculationTypeEditorProps, type ScoreMultiplyRewardCalculationTypeModel } from '@/lib/action-modules/registry/reward/types'

export default function ScoreMultiplyRewardEditor(props: RewardCalculationTypeEditorProps) {
  const { t } = useTranslation('action-modules-wizard')
  const value = props.value
  if (!isScoreMultiplyRewardCalculationTypeModel(value)) return <>{t('editor.invalidValue')}</>

  return (
    <div className="flex max-w-sm flex-col gap-2">
      <HelpLabel helpKey={helpKey('rewardScoreMultiplyFactor')}>
        {t('rewardCalculationType.scoreMultiply.factor')}
      </HelpLabel>
      <Input
        type="number"
        value={value.factor}
        onChange={e =>
          props.onChanged({ ...value, factor: Number(e.target.value) } as ScoreMultiplyRewardCalculationTypeModel)
        }
      />
    </div>
  )
}
